import { useState } from 'react';
import { AxiosError } from 'axios';
import toast from 'react-hot-toast';
import useHttps from '../useHttps';
import {
  HttpConfig,
  SuccessHttpResponse,
  ErrorHttpResponse,
} from '../../models/https';
import { useDispatch } from 'react-redux';
import { jobCreatedListActions } from '../../redux/slices/jobCreatedListSlice';
import { useAppSelector } from '../../redux/store';

const useDeleteJob = (jobId: string) => {
  const [loading, setLoading] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const request = useHttps();
  const dispatch = useDispatch();

  // Use your Redux selector to find the permission for this job.
  const jobPermission = useAppSelector((state) =>
    state.jobPermissions.permissions.find((perm) => perm.jobId === jobId)
  );

  const deleteJob = async () => {
    setLoading(true);
    // check for applicants before deletion if needed
    if (!jobPermission?.canDelete) {
      toast.error('Can not delete job with active applicants');
      setLoading(false);
      return;
    }

    try {
      const config: HttpConfig = {
        url: `jobs-service/jobs/${jobId}`,
        method: 'delete',
      };

      // Define success callback
      const onSuccess = ({ data }: SuccessHttpResponse<null>) => {
        toast.success('Job deleted successfully!');
        setLoading(false);
        setDeleted(true);
        // Dispatch action to remove the job from the Redux store
        dispatch(jobCreatedListActions.removeJob(jobId));
        return data;
      };

      // Define error callback
      const onError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(err?.response?.data?.message ?? 'Failed to delete job');
        setLoading(false);
        setDeleted(false);
        throw err;
      };

      // Execute the request
      return request(config, onSuccess, setLoading, onError);
    } catch (error) {
      setLoading(false);
      setDeleted(false);
      throw error;
    }
  };

  return {
    deleted,
    loading,
    deleteJob,
  };
};

export default useDeleteJob;
